import React from 'react'
import axios from 'axios'

import Cidades from '../Cidades/Cidades.js'

import Cabecalho from '../Views/Form/Cabecalho'
import Button from '../Form/Button'

export default class ProcessoCapa extends React.Component {
    constructor(props) {
        super(props)
        this.state = { modificado: { user: localStorage.nome, dataAlteracao: new Date() }, button: false }
    }

    componentDidMount() {
        const id = this.props.match.params.id
        const url = `/api/ficha/processo/${id}`
        axios(url)
            .then(resp => {
                this.setState({ ficha: resp.data })
            })
            .catch(error => {
                alert(error)
            }
            )
    }

    updateField(event) { 
        const ficha = { ...this.state.ficha }
        ficha[event.target.name] = event.target.value
        this.setState({ ficha })
        let cidades = Cidades[event.target.value]
        if (event.target.name == 'uf') {
            let uf = event.target.value
            const url = `ht://servicodados.ibge.gov.br/api/v1/localidades/estados/${uf}/municipios`
            axios.get(url, ficha)
                .then(resp => {
                    this.setState({ municipios: resp.data })
                })
                .catch(error => {
                    this.setState({ municipios: cidades })
                })
        }
    }

    save(e) {
        e.preventDefault()
        this.setState({button: true})
        const id = this.props.match.params.id
        const url = `/api/processo/edita/${id}`
        const ficha = this.state.ficha
        const modificado = this.state.modificado
        const data = { ficha, modificado }
        axios.post(url, data)
            .then(res => {
                alert('Processo editado com sucesso!')
                window.location = `/documentos/${this.props.match.params.id}`
            })
            .catch(error => {
                alert(error.response.data)
                this.setState({button: false})
            })
    }

    render() {
        if (this.state.ficha) {
            let ano = this.state.ficha.data.slice(0, 4)
            let mes = this.state.ficha.data.slice(5, 7)
            let dia = this.state.ficha.data.slice(8, 10)
            let data = dia + "/" + mes + "/" + ano 
            return (
                <React.Fragment>
                    <div className="container">
                        <Cabecalho valor={this.state.ficha} />
                        <div className="form-group row mt-3 text-left">
                            <label className="col-3">Processo:</label>
                            <div className="col-9 mb-3">
                                <input type="text" className="form-control"
                                    name="numero"
                                    onChange={e => this.updateField(e)}
                                    value={this.state.ficha.numero} />
                            </div>
                        </div>
                        <div className="form-group row mt-3 text-left">
                            <label className="col-3 col-md-3">Data:</label>
                            <div className="col-9 col-md-2 mb-3">
                                <input type="text" className="form-control"
                                    name="data"
                                    onChange={e => this.updateField(e)}
                                    value={data} />
                            </div>
                        </div>
                        <div className="mt-5 font-weight-bold text-left">
                            1 - DADOS DO ESTABELECIMENTO:
                        </div>
                        <div className="form-group row mt-3 text-left">
                            <label className="col-4 col-md-2">Estabelecimento:</label>
                            <div className="col-8 col-md-4 mb-3">
                                <input type="text" className="form-control"
                                    name="estabelecimento"
                                    onChange={e => this.updateField(e)}
                                    value={this.state.ficha.estabelecimento} />
                            </div>
                            <label className="col-3 col-md-2">Nome Fantasia:</label>
                            <div className="col-9 col-md-4 mb-3">
                                <input type="text" className="form-control"
                                    name="fantasia"
                                    onChange={e => this.updateField(e)}
                                    value={this.state.ficha.fantasia} />
                            </div>
                            <label className="col-3 col-md-2">Registro:</label>
                            <div className="col-9 col-md-4 mb-3">
                                <input type="text" className="form-control"
                                    name="registro"
                                    onChange={e => this.updateField(e)}
                                    value={this.state.ficha.registro} />
                            </div>
                            <div className="col-12 col-md-6"></div>
                            <label className="col-3 col-md-2">Endereço:</label>
                            <div className="col-9 col-md-4 mb-3">
                                <input type="text" className="form-control"
                                    name="endereco"
                                    onChange={e => this.updateField(e)}
                                    value={this.state.ficha.endereco} />
                            </div>
                            <label className="col-3 col-md-2">UF:</label>
                            <div className="col-9 col-md-4 mb-3">
                                <input type="text" className="form-control"
                                    name="uf"
                                    onChange={e => this.updateField(e)}
                                    value={this.state.ficha.uf} />
                            </div>
                            <label className="col-3 col-md-2">Município:</label>
                            <div className="col-9 col-md-2 mb-3">
                                <input type="text" className="form-control"
                                    name="municipio"
                                    onChange={e => this.updateField(e)}
                                    value={this.state.ficha.municipio} />
                            </div>
                            <label className="col-3 col-md-2">CEP:</label>
                            <div className="col-9 col-md-2 mb-3">
                                <input type="text" className="form-control"
                                    name="cep"
                                    onChange={e => this.updateField(e)}
                                    value={this.state.ficha.cep} />
                            </div>
                            <label className="col-3 col-md-2">Telefone:</label>
                            <div className="col-9 col-md-2 mb-3">
                                <input type="text" className="form-control"
                                    name="telefone"
                                    onChange={e => this.updateField(e)}
                                    value={this.state.ficha.telefone} />
                            </div>
                            <label className="col-4 col-md-2">Situação:</label>
                            <div className="col-8 col-md-4 mb-3">
                                <input type="text" className="form-control"
                                    name="setor"
                                    onChange={e => this.updateField(e)}
                                    value={this.state.ficha.setor} />
                            </div>
                            <label className="col-4 col-md-2">Tipo:</label>
                            <div className="col-8 col-md-4 mb-3">
                                <input type="text" className="form-control"
                                    name="tipo"
                                    onChange={e => this.updateField(e)}
                                    value={this.state.ficha.tipo} />
                            </div>
                            <label className="col-12">Observações:</label>
                            <textarea type="textarea" rows="3" className="form-control" 
                            name="obs"
                            onChange={e => this.updateField(e)}
                            value={this.state.ficha.obs} />
                            {/* <div className="form-control textarea text-left mb-5">{this.state.ficha.obs}</div> */}
                        </div>
                        <Button onClick={e => this.save(e)} disabled={this.state.button}/>
                    </div>
                </React.Fragment> 
            )
        } else {
            return <div></div>
        }
    }
}